import { Row, Col, Card, Tag, Typography, Space, Avatar, Button } from "antd";
import { useEffect, useState } from "react";
import { SwapOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import PullToRefresh from "react-simple-pull-to-refresh";
import GETListarDisponibles from "../../helpers/ordenes/GETListarDisponibles";
import { getTipoTagProps } from "../../utils/getTipoTragProp";
import { formatFecha } from "../../utils/formatFecha";
import { getCardStyle } from "../../utils/getCardStyle";
import { estadoConfig } from "../../utils/getEstadoProp";
import POSTNuevaReubicacion from "../../helpers/ordenes/POSTNuevaReubicacion";
import HeaderEstandar from "../../components/layout/headers/HeaderEstandar";
import AppLayout from "../../components/layout/AppLayout";
import Loader from "../../components/loader/Loader";
import ActionResultModal from "../../components/actionResultModal.js/ActionResultModal";
import { useAuth } from "../../AuthContext";

const { Text } = Typography;

const Reubicaciones = ({ darkMode, setDarkMode }) => {
  const { loggedUser } = useAuth();
  const navigate = useNavigate();
  const [ordenes, setOrdenes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState({
    open: false,
    message: "",
    type: "success",
    orden: null,
    modalType: null,
  });

  const headerComponent = (
    <HeaderEstandar data={{ headerTitle: "Mis Reubicaciones" }} />
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await GETListarDisponibles("REU");
        if (Array.isArray(response?.data)) {
          setOrdenes(response.data);
        } else {
          console.warn("La respuesta no es un array válido:", response);
          setOrdenes([]);
        }
      } catch (error) {
        console.error("Error al cargar órdenes:", error);
        setOrdenes([]);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [loggedUser]);

  const handleRefresh = async () => {
    setLoading(true);
    try {
      const response = await GETListarDisponibles("REU");
      if (Array.isArray(response?.data)) {
        setOrdenes(response.data);
      } else {
        setOrdenes([]);
      }
    } catch (error) {
      console.error("Error al refrescar órdenes:", error);
      setOrdenes([]);
    } finally {
      setLoading(false);
    }
  };

  const handleNuevaReubicacion = async () => {
    try {
      const response = await POSTNuevaReubicacion();
      if (response?.status === 200) {
        setModal({
          open: true,
          message: response.data?.descri || "Reubicación creada exitosamente.",
          type: "success",
          orden: response?.data?.codoma,
          modalType: "reubicacion",
        });
      } else {
        setModal({
          open: true,
          message:
            response?.data?.message || "No se pudo crear la reubicación.",
          type: "error",
          modalType: null,
        });
      }
    } catch (error) {
      console.error("Error al crear reubicación:", error);
      setModal({
        open: true,
        message: "Ocurrió un error inesperado.",
        type: "error",
        modalType: null,
      });
    }
  };

  const closeModal = () =>
    setModal({
      open: false,
      message: "",
      type: "success",
      orden: null,
      modalType: null,
    });

  return (
    <AppLayout
      darkMode={darkMode}
      setDarkMode={setDarkMode}
      header={headerComponent}
    >
      <PullToRefresh
        onRefresh={handleRefresh}
        maxPullDownDistance={80}
        refreshingContent={null}
        pullingContent={null}
      >
        <div
          style={{
            height: "100%",
            padding: "8px",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          {loading && <Loader />}

          <Row gutter={[8, 8]} justify="start" align="stretch">
            <Col span={24}>
              <Button
                type="primary"
                block
                size="large"
                style={{
                  backgroundColor: "#8E44AD",
                  borderColor: "#8E44AD",
                }}
                onClick={() => handleNuevaReubicacion()}
              >
                Nueva reubicación
              </Button>
            </Col>

            {/* Contenido principal */}
            {ordenes.length === 0 && !loading ? (
              <Col span={24}>
                <Card
                  style={{
                    textAlign: "center",
                    backgroundColor: darkMode ? "#1f1f1f" : "#fafafa",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "32px",
                  }}
                >
                  <Text type="secondary" style={{ fontSize: "19px" }}>
                    No hay reubicaciones disponibles.
                  </Text>
                </Card>
              </Col>
            ) : (
              ordenes.map((orden) => {
                const estado = estadoConfig[orden.estado];
                const tipo = {
                  color: "purple",
                  text: "Reubicación",
                  icon: <SwapOutlined />,
                };

                return (
                  <Col
                    span={24}
                    key={orden.idomam || orden.numero}
                    style={{ display: "flex" }}
                  >
                    <Card
                      onClick={() => {
                        if (orden.idomam) {
                          navigate(`/reubicaciones/${orden.idomam}`, {
                            state: { esREU: true },
                          });
                        }
                      }}
                      hoverable
                      styles={{ body: { padding: 16 } }}
                      style={{
                        ...getCardStyle(darkMode),
                        height: "100%",
                        flex: 1,
                      }}
                    >
                      <Row align="middle" justify="space-between">
                        <Space align="start">
                          <Avatar
                            src="/assets/mov_articulos.png"
                            size={60}
                            style={{ backgroundColor: "#ffcc00" }}
                          />
                          <div>
                            <Text
                              strong
                              style={{
                                fontSize: "22px",
                                color: darkMode ? "#fff" : "#000",
                              }}
                            >
                              {orden.numero}
                            </Text>
                            <br />
                            <Text type="secondary" style={{ fontSize: 16 }}>
                              {formatFecha(orden.fecha)}
                            </Text>
                          </div>
                        </Space>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            minWidth: 120,
                            marginTop: 8,
                          }}
                        >
                          <Tag
                            color={estado?.color}
                            icon={estado?.icon}
                            style={{
                              fontSize: 17,
                              width: 120,
                              textAlign: "center",
                            }}
                          >
                            {estado?.text}
                          </Tag>
                        </div>
                      </Row>

                      <Space
                        direction="vertical"
                        size="small"
                        style={{ marginTop: 8, width: "100%", flex: 1 }}
                      >
                        {orden.sucursalinicial && (
                          <div>
                            <Tag
                              color={darkMode ? "geekblue" : "blue"}
                              style={{ fontSize: 16 }}
                            >
                              SUC
                            </Tag>
                            <Text
                              style={{
                                color: darkMode ? "#ccc" : "#333",
                                fontSize: 16,
                              }}
                            >
                              {orden.sucursalinicial}
                            </Text>
                          </div>
                        )}

                        {orden.comprobantesma && (
                          <div>
                            <Tag color="purple" style={{ fontSize: 16 }}>
                              WMS
                            </Tag>
                            <Text
                              style={{
                                color: darkMode ? "#ccc" : "#333",
                                fontSize: 16,
                              }}
                            >
                              {orden.comprobantesma}
                            </Text>
                          </div>
                        )}

                        {orden.comprobanteerp && (
                          <div>
                            <Tag color="purple" style={{ fontSize: "16px" }}>
                              ERP
                            </Tag>
                            <Text
                              style={{
                                color: darkMode ? "#ccc" : "#333",
                                fontSize: "16px",
                              }}
                            >
                              {orden.comprobanteerp}
                            </Text>
                          </div>
                        )}

                        <div
                          style={{ display: "flex", flexWrap: "wrap", gap: 8 }}
                        >
                          {tipo && (
                            <Tag
                              color={tipo.color}
                              icon={tipo.icon}
                              style={{ fontSize: 16 }}
                            >
                              {tipo.text}
                            </Tag>
                          )}
                          {orden.tiposma && (
                            <Tag
                              color={getTipoTagProps(orden.tiposma).color}
                              icon={getTipoTagProps(orden.tiposma).icon}
                              style={{ fontSize: 16 }}
                            >
                              {orden.tiposma}
                            </Tag>
                          )}
                        </div>
                      </Space>
                    </Card>
                  </Col>
                );
              })
            )}
          </Row>
        </div>
      </PullToRefresh>

      <ActionResultModal
        open={modal.open}
        onClose={closeModal}
        type={modal.type}
        message={modal.message}
        orden={modal.orden}
        modalType={modal.modalType}
      />
    </AppLayout>
  );
};

export default Reubicaciones;
